/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BrowserRegistrationSettings} from '../models/BrowserRegistrationSettings';
import type {Error} from '../models/Error';

export interface GetBrowserRegistrationSettings$Request {
    userId: number;
}

export interface GetBrowserRegistrationSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBrowserRegistrationSettingsRequest = createAction<PayloadData<void, GetBrowserRegistrationSettings$Request>>('GET_BROWSER_REGISTRATION_SETTINGS__GET_BROWSER_REGISTRATION_SETTINGS__REQUEST');
export const getBrowserRegistrationSettingsSuccess = createAction<PayloadData<BrowserRegistrationSettings, GetBrowserRegistrationSettings$Request>>('GET_BROWSER_REGISTRATION_SETTINGS__GET_BROWSER_REGISTRATION_SETTINGS__SUCCESS');
export const getBrowserRegistrationSettingsFailure = createAction<PayloadData<Error, GetBrowserRegistrationSettings$Request, true>>('GET_BROWSER_REGISTRATION_SETTINGS__GET_BROWSER_REGISTRATION_SETTINGS__FAILURE');

export const getBrowserRegistrationSettingsActions = [
    getBrowserRegistrationSettingsRequest,
    getBrowserRegistrationSettingsSuccess,
    getBrowserRegistrationSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBrowserRegistrationSettings = (meta: GetBrowserRegistrationSettings$Request, config?: GetBrowserRegistrationSettings$Config) => {
    return {
        CALL_API: {
            types: getBrowserRegistrationSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/browser-registration/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

